import script from "./AdminReportingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminReportingPage.vue?vue&type=script&setup=true&lang=js"

import "./AdminReportingPage.vue?vue&type=style&index=0&id=45142027&lang=scss&scoped=true"
import "./AdminReportingPage.vue?vue&type=style&index=1&id=45142027&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45142027"]])

export default __exports__